import { getUser } from "../utils";
import type { LinkedAccount } from "../../types/linked-accounts";

// MarketingOnly accounts aren't linked to a `hotels` row, so `hotelName` is null
// and the "hotel identity" lives in userFirstName/userLastName instead.
export function getMemberDisplayName(m: LinkedAccount): string | null {
  if (m.hotelName) return m.hotelName;
  const fullName = `${m.userFirstName ?? ""} ${m.userLastName ?? ""}`.trim();
  return fullName || m.userEmail || null;
}

export function useCurrentProperty(): {
  currentHotelName: string | null;
  linkedAccounts: LinkedAccount[];
  isLinked: boolean;
} {
  // Not memoized: recompute each render so a hotel switch (which rewrites the
  // cached user) is reflected immediately in always-on consumers like the
  // mobile header, not frozen at mount.
  const user = getUser();
  const linkedAccounts: LinkedAccount[] = Array.isArray(user?.linkedAccounts)
    ? user.linkedAccounts
    : [];
  const currentMember = linkedAccounts.find((m) => m.isCurrent);
  // MarketingOnly / single-property accounts have no linked member and a null
  // currentHotel.name, so fall back to the user's own identity. Without this
  // the name stays null, PropertySwitcher returns null, and the only Sign-out
  // button vanishes — leaving those users unable to log out.
  const ownName = `${user?.firstName ?? ""} ${user?.lastName ?? ""}`.trim();
  const currentHotelName: string | null =
    (currentMember && getMemberDisplayName(currentMember)) ??
    user?.currentHotel?.name ??
    (ownName || user?.email) ??
    null;
  return {
    currentHotelName,
    linkedAccounts,
    isLinked: linkedAccounts.length >= 2,
  };
}
